import { useContext, useMemo } from 'react';

import { ChainContext } from '../chain.context';

export const useChainStatus = () => {
  const context = useContext(ChainContext);
  if (!context) {
    throw new Error('useChainStatus must be used within a ChainProvider');
  }

  const { loading, error } = context;

  const result = useMemo(() => {
    return {
      loading,
      error,
    };
  }, [loading, error]);

  return result;
};
